<template>
	<v-container grid-list-xl>
		<v-layout row wrap>			
			<v-flex lg6>			
				<label class="blackLabel">Date From:</label>
				<date-picker style="width: 100% !important" v-model="objDiscountReportFilters.startDate" lang="en"></date-picker>
			</v-flex>
			<v-flex lg6>			
				<label class="blackLabel">Date To:</label>
				<date-picker style="width: 100% !important" v-model="objDiscountReportFilters.endDate" lang="en"></date-picker>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Requestor:</label>				
				<v-select :items="discountRequestors" v-model="objDiscountReportFilters.requestor" label="Select Requestor" item-value="id" autocomplete solo></v-select>				
			</v-flex>
			<v-flex lg6>			
				<label class="blackLabel">Authoriser:</label>
				<v-select :items="discountAuthorisers" v-model="objDiscountReportFilters.authorizer" label="Select Authorizer" item-value="id" autocomplete solo></v-select>
			</v-flex>
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
					<v-btn color="success" class="text-xs-right" @click.stop="fncClearFilters()">Clear Filter</v-btn>
					<v-btn color="success" class="text-xs-right" @click.stop="fncGenerateDiscountReport()">Generate</v-btn>
				</div>	
			</div>	
			<v-flex lg12 class="requiredMessage" style="padding-bottom: 75px;">
				&nbsp;
			</v-flex>			
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import draggable from 'vuedraggable'
	import DatePicker from 'vue2-datepicker'
	export default {
	  name: 'Settings',
	  data () {
			return {                
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncClearFilters() {
				this.objDiscountReportFilters.startDate = '';
				this.objDiscountReportFilters.endDate = '';
				this.objDiscountReportFilters.requestor = '';
				this.objDiscountReportFilters.authorizer = '';
				/*localStorage.setItem('discountStartDate', '');
				localStorage.setItem('discountEndDate', '');
				localStorage.setItem('discountRequestor', '');	
				localStorage.setItem('discountAuthoriser', '');*/
			},
			fncGenerateDiscountReport() {					
			    this.$store.dispatch({
					type: 'fncPopulateDiscountList',
					objFilters: this.objDiscountReportFilters
				})
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams',
				'discountRequestors',
				'discountAuthorisers',
				'objDiscountReportFilters'
				
			])
		},
		created() {
		},
		 components: {
			  draggable,
			  DatePicker			  
		  }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>